import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  Table,
  FormGroup,
} from "reactstrap";
import { post, put, doPortChange, get } from "helpers/api_helper";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import OptionsMenu from "components/OptionsMenu";
//   import * as api from "../../../constants/api_constants";
import CustomPagination from "components/CustomPagination";
import SummaryCards from "components/SummaryCards";
import { showErrorToast, showSuccessToast } from "helpers/toastMessages";
import { CustomButton } from "components/CommonInputs/CustomButtons/CustomButton";

function Subscription() {
  const navigate = useNavigate();
    const { id } = useParams();
  

  const [subscriptions, setSubscriptions] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const timerRef = useRef(null);

  // const fetchPaymentsData = useCallback(async (query, page = 1) => {
  //   try {
  //     const data = await post(api.GET_ALL_PAYMENTS, {
  //       page: page - 1,
  //       pageSize: 10,
  //       searchKeyword: query?.trim() ?? "",
  //     });
  //     const fetchedData = data.data.data;
  //    // console.log(data.paginationResponse.data.length);
  //     setPayments(fetchedData);
  //     if (data.success) {
  //       const fetchedData = data.data.data;
  //       setPayments(fetchedData);
  //       console.log(data.data.totalItems);
  //       setTotalPages(data.data.totalPages);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching payments:", error);
  //   }
  // }, []);

  // useEffect(() => {
  //   fetchPaymentsData();
  // }, [fetchPaymentsData]);

  // const handlePageChange = useCallback(
  //   (page) => {
  //     setCurrentPage(page);
  //     fetchPaymentsData(searchQuery, page);
  //   },
  //   [fetchPaymentsData, searchQuery]
  // );
  // console.log("Current Page:", currentPage);
  // console.log("Total Pages:", totalPages);

  // const handleSearch = useCallback(
  //   (e) => {
  //     setSearchQuery(e.target.value ?? "");

  //     const query = e.target.value || "";

  //     if (timerRef.current) {
  //       clearTimeout(timerRef.current);
  //     }

  //     timerRef.current = setTimeout(() => {
  //       fetchPaymentsData(query?.trim());
  //     }, 300);
  //   },
  //   [fetchPaymentsData]
  // );

  const summaryData = [
    {
      iconClass: "fas fa-users text-info",
      label: "Total Subscriptions",
      value: 100,
    },
    {
      iconClass: "fa-solid fa-dollar-sign text-primary",
      label: "Active",
      value: 100,
    },
    {
      iconClass: "fa-solid fa-dollar-sign text-warning",
      label: "Pending",
      value: 34,
    },
    {
      iconClass: "fa-solid fa-dollar-sign text-danger",
      label: "Expired",
      value: 34,
    },
  ];

  const handleEdit = useCallback(
    (id) => {
      navigate(`/add-subscription/${id}`);
    },
    [navigate]
  );

  const formatDateManually = (date) => {
    const d = new Date(date);
    const month = (d.getMonth() + 1).toString().padStart(2, "0"); // Adding 1 because getMonth() returns 0-11
    const day = d.getDate().toString().padStart(2, "0");
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const subscriptionData = [
    {
      id: 1,
      subscriberName: "John Doe",
      subscriptionPlan: "Advance",
      startDate: "2025-01-01",
      email : "John@gmail.com",
      expiryDate: "2026-01-01",
      subscriptionStatus: "Active",
      paymentStatus: "Paid",
      nextPaymentDue: "2026-01-01",
    },
    {
      id: 2,
      subscriberName: "Jane Smith",
      subscriptionPlan: "Basic",
      
      startDate: "2025-03-15",
      expiryDate: "2026-03-15",
      subscriptionStatus: "Active",
      paymentStatus: "Paid",
      nextPaymentDue: "2026-03-15",
      email : "Jane@gmail.com",
    },
    {
      id: 3,
      subscriberName: "Robert Brown",
      subscriptionPlan: "Pro",
      startDate: "2024-10-10",
      expiryDate: "2025-10-10",
      subscriptionStatus: "Expired",
      paymentStatus: "Unpaid",
      nextPaymentDue: "N/A",
      email : "Robert@gmail.com",
    },
    {
      id: 4,
      subscriberName: "Alice Johnson",
      subscriptionPlan: "Basic",
      startDate: "2023-07-20",
      expiryDate: "2024-07-20",
      subscriptionStatus: "Active",
      paymentStatus: "Paid",
      nextPaymentDue: "2024-07-20",
      email : "Alice@gmail.com",
    },
    {
      id: 5,
      subscriberName: "Michael Green",
      subscriptionPlan: "Advance",
      startDate: "2024-01-12",
      expiryDate: "2025-01-12",
      subscriptionStatus: "Active",
      paymentStatus: "Paid",
      nextPaymentDue: "2025-01-12",
      email : "Michael@gmail.com",
    },
    {
      id: 6,
      subscriberName: "Emily Clark",
      subscriptionPlan: "Pro",
      startDate: "2023-12-01",
      expiryDate: "2024-12-01",
      subscriptionStatus: "Active",
      paymentStatus: "Paid",
      nextPaymentDue: "2024-12-01",
      email : "Emily@gmail.com",
    },
    {
      id: 7,
      subscriberName: "Chris Evans",
      subscriptionPlan: "Basic",
      startDate: "2024-02-01",
      expiryDate: "2025-02-01",
      subscriptionStatus: "Expired",
      paymentStatus: "Unpaid",
      nextPaymentDue: "N/A",
      email : "Chris@gmail.com"
    },
    {
      id: 8,
      subscriberName: "Natalie Portman",
      subscriptionPlan: "Advance",
      startDate: "2024-05-10",
      expiryDate: "2025-05-10",
      subscriptionStatus: "Active",
      paymentStatus: "Paid",
      nextPaymentDue: "2025-05-10",
      email : "Natalie@gmail.com",
    },
  ];

  return (
    <>
      <div className="page-content">
        <Container fluid={true} className="py-0 px-0">
          <PageSubHeader
            heading={"Subscriptions"}
            routePath={"Home"}
            pageName={"Subscriptions"}
          />
          <Row className="px-4">
            <SummaryCards data={summaryData} />

            <Row>
              <Col>
                <Row className="d-flex justify-content-between align-items-center py-2">
                  <Col xs={3}>
                    <InputGroup size="sm" className="elbert-search-group">
                      <Input
                        placeholder="Search, Company Name, Email"
                        className="elbert-search"
                        //   onChange={handleSearch}
                        //   value={searchQuery}
                      />
                      <InputGroupText>
                        <span className="fa fa-search"></span>
                      </InputGroupText>
                    </InputGroup>
                  </Col>
                  <Col xs={3}></Col>
                  <Col
                    xs={2}
                    className="d-flex align-items-center justify-content-end"
                  >
                    {/* <Button
                        color="primary"
                        outline
                        className="waves-effect waves-light"
                        onClick={() => navigate("/add-payment")}
                      >
                        + Add New
                      </Button> */}
                    <CustomButton
                      text={"+ Add New"}
                      onClick={() => navigate("/add-subscription")}
                    />
                  </Col>
                </Row>

                <Row>
                  <Card>
                    <CardBody>
                      <div className="table-responsive">
                        <Table className="table mb-0">
                          <thead>
                            <tr>
                              <th>Subscriber Name</th>
                              <th>Subscription Plan</th>
                              <th>Email</th>
                              <th>Start Date</th>
                              <th>Expiry Date</th>
                              <th>Subscription Status</th>
                              <th>Payment Status</th>
                              <th>Next Payment Due</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {subscriptionData.map((subscription) => (
                              <tr key={subscription.id}>
                                <td>{subscription.subscriberName}</td>
                                <td>{subscription.subscriptionPlan}</td>
                                <td>{subscription.email}</td>
                                <td>{subscription.startDate}</td>
                                <td>{subscription.expiryDate}</td>
                                <td>{subscription.subscriptionStatus}</td>
                                <td>{subscription.paymentStatus}</td>
                                <td>{subscription.nextPaymentDue}</td>
                                <td>
                                  <div className="d-flex gap-3 align-items-center">
                                    <i
                                      className="fa-solid fa-eye action-icon"
                                      title="View"
                                      onClick={() =>
                                        navigate(`/view-subscription`)
                                      }
                                    ></i>
                                    <i
                                      onClick={() => handleEdit(`${subscription.id}`)}
                                      className="fa-regular fa-pen-to-square action-icon"
                                      title="Edit"
                                    ></i>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                </Row>
              </Col>
            </Row>
            {/* <CustomPagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              /> */}
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Subscription;
